import { LitElement, html, css } from "lit";

export class Accordion extends LitElement {
  static properties = {
    title: { type: String },
    content: { type: String },
  };

  static styles = css`
    // :host {
    //   min-width: fit-content;
    // }
    :root { 
      --icon-arrow: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNNDQwLTgwMHY0ODdMMjE2LTUzN2wtNTYgNTcgMzIwIDMyMCAzMjAtMzIwLTU2LTU3LTIyNCAyMjR2LTQ4N2gtODBaIi8+PC9zdmc+");

      --icon-chevron: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iYmxhY2siIGQ9Ik03LjQxIDguNTkgMTIgMTMuMTdsNC41OS00LjU4TDE4IDEwbC02IDYtNi02eiIvPjwvc3ZnPg==");
    }

    /* Base details container */
    details.aim-accordion {
      position: relative;
      border-radius: var(--accordian__btn__border-radius, 1px);
      transition: box-shadow .2s ease;
    }

    /* Base summary */
    details.aim-accordion > summary {
      background: var(--accordian__btn__bg, #eff6ff);
      border: var(--accordian__btn__border, 2px solid transparent);
      border-bottom: var(--accordian__btn__border_bottom-width, 2px) solid var(--accordian__btn__border_bottom, #121c4d);
      border-radius: var(--accordian__btn__border-radius, 1px);
      color: var(--accordian__btn__color, var(--black__text, #000));
      font-size: 1.125rem;
      font-weight: var(--accordian__btn_fw, var(--f-w-2, bolder));
      text-align: left;
      list-style: none;
      margin: 0 0 var(--accordian__titlebutton__padding, 5px);
      padding: 18px 47px 18px 64px;
      position: relative;
      cursor: pointer;
      display: list-item;
    }

    /* Circle chip behind icon */
    details.aim-accordion > summary::after {
      content: "";
      position: absolute;
      margin-left: -50px;
      margin-top: -4px;

      /* Circle size = icon size + 2 * padding (6px) */
      width: calc(var(--accordian__icon__size, 1.4rem) + 12px);
      height: calc(var(--accordian__icon__size, 1.4rem) + 12px);

      background: var(--accordian__icon__chip_bg, var(--accordian__icon__bg, #fff));
      border-radius: var(--accordian__icon__chip_border-radius, var(--accordian__icon__border-radius, 50%));

      /* place behind chevron */
      z-index: 0;
    }

    /* Icon (base64 SVG via mask) */
    details.aim-accordion > summary::before {
      content: "";
      background: var(--accordian__icon__bg, #fff);
      background-color: var(--accordian__icon__color, var(--black__text)); /* mask paints from bg-color */
      border-radius: var(--accordian__icon__border-radius, 50%);
      
      --icon-chewron: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iYmxhY2siIGQ9Ik03LjQxIDguNTkgMTIgMTMuMTdsNC41OS00LjU4TDE4IDEwbC02IDYtNi02eiIvPjwvc3ZnPg=="); 
      --icon-arrow: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMDAwIj48cGF0aCBkPSJNNDQwLTgwMHY0ODdMMjE2LTUzN2wtNTYgNTcgMzIwIDMyMCAzMjAtMzIwLTU2LTU3LTIyNCAyMjR2LTQ4N2gtODBaIi8+PC9zdmc+");
      
      --_icon: var(--icon-arrow); 
      -webkit-mask-image: var(--accordian__icon__data, var(--_icon));
      mask-image: var(--accordian__icon__data, var(--_icon));
      -webkit-mask: var(--accordian__icon__data, var(--_icon)) center / contain no-repeat;
      mask: var(--accordian__icon__data, var(--_icon)) center / contain no-repeat;
      display: inline-block;
      width: var(--accordian__icon__size, 1.4rem);
      height: var(--accordian__icon__size, 1.4rem);
      padding: 6px;
      position: absolute;
      margin-left: -50px;
      margin-top: -4px;
      transition: transform .3s ease;
    }

    /* Open state (outer container + summary + icon) */
    details[open].aim-accordion {
      box-shadow: var(--accordian__open_box-shadow, rgba(0, 0, 0, 0.24) 0 3px 8px);
      background: var(--accordian__content__bg, #fff);
    }
    details[open].aim-accordion > summary {
      background: var(--accordian__btn__open_bg_color, var(--accordian__btn__bg, #eff6ff));
      color: var(--accordian__btn__text_color);
      margin-bottom: 0;
    }
    details[open].aim-accordion > summary::before {
      background: var(--accordian__icon__bg_open, #fff);
      background-color: var(--accordian__icon__color_open, var(--black__text));
      transform: rotate(180deg);
    }

    /* Hover */
    details.aim-accordion > summary:hover {
      background-color: var(--accordian__btn__bg_color_hover, var(--accordian__btn__bg, #eff6ff));
      border: var(--accordian__btn__border-width, 2px) solid var(--accordian__btn__border_hover, #121c4d);
      border-bottom: var(--accordian__btn__border_bottom-width, 2px) solid var(--accordian__btn__border-bottom-color_hover, #121c4d);
      outline: 0;
    }

    /* Optional keyboard focus */
    details.aim-accordion > summary:focus-visible {
      background-color: var(--accordian__btn__bg_color_hover, var(--accordian__btn__bg, #eff6ff));
      border: var(--accordian__btn__border-width, 2px) solid var(--accordian__btn__border_hover, #121c4d);
      border-bottom: var(--accordian__btn__border_bottom-width, 2px) solid var(--accordian__btn__border-bottom-color_hover, #121c4d);
      outline: 0;
    }

    /* Open content (padding + container) */
    details[open].aim-accordion > div,
    details[open].aim-accordion > p {
      padding: var(--accordian__content__padding, 30px 30px 20px);
      background: var(--accordian__content__bg, #fff);
      border: 2px solid var(--accordian__content__border_color, #fff);
      border-top: none;
      margin-bottom: 15px;
      overflow-wrap: break-word;
      box-shadow: none; /* avoid double-shadow; outer shadow is on <details> */
    }

    /* Responsive icon size */
    @media (min-width: 768px) {
      details.aim-accordion > summary::before {
        width: var(--accordian__icon__size-md, 1.7rem);
        height: var(--accordian__icon__size-md, 1.7rem);
      }
    }
  `;

  // constructor() {
  //   super();
  // }

  render () {
    return html`
      <details class="aim-accordion"><summary>${this.title}</summary><div>${this.content}</div></details>`;
  }
}

customElements.define("aim-accordion", Accordion);
